// AI-CONTEXT: See docs/features/participation-ladder.md
import formatEuro from '../../../helpers/formatEuro'
import { LADDER_LABELS } from '../../../helpers/participationHelpers/participationOptions'
import usePersonaTerms from '../../../hooks/usePersonaTerms'

// Bedragen van één meetmoment onder 2026.3. De eerste vier staan er altijd;
// de regelingen alleen als ze bij dit meetmoment iets kosten of opleveren.
const postsModelRows = (state, personaTerms) => [
    { label: 'Bruto loon', value: state.loon, always: true },
    { label: 'Uitkering', value: state.uitkering, always: true },
    { label: 'Belasting en premies', value: -state.belasting, always: true },
    { label: `Netto inkomen ${personaTerms.singularLower}`, value: state.deelnemerNetto, always: true },
    { label: 'Verwachte loonwinst na opleiding', value: state.loonwinst },
    { label: 'Uitvoeringskosten bijstand', value: -state.uitvoering },
    { label: 'Loonkostensubsidie', value: state.lks },
    { label: 'Dagbesteding', value: -state.dagbesteding },
    { label: 'Waarde vrijwilligerswerk', value: state.vrijwilligerswerk },
].filter((row) => row.always || row.value)

// Trede badge + read-only breakdown of one computed participation state.
/**
 * @param {object} props
 * @param {object} props.state - Eén meetmoment uit calculateParticipationImpact (t0 of t1)
 * @param {'posts'|'legacy'} [props.model] - Rekenmodel van de uitkomst; bepaalt de regels
 * @param {string} [props.label] - Kop boven de bedragen
 * @param {string} [props.meta] - Kleine tekst naast de kop (bv. laatst bijgewerkt)
 * @param {boolean} [props.muted] - Gedempte trede (beginsituatie)
 */
const ParticipationResult = ({ state, model = 'legacy', label = 'Berekend resultaat', meta, muted = false }) => {
    const personaTerms = usePersonaTerms()

    if (!state) return null

    const rows = model === 'posts' ? postsModelRows(state, personaTerms) : [
        { label: 'Productiviteit', value: state.incomePerson },
        { label: 'Inkomstenbelasting', value: state.incomeTax },
        { label: `Netto inkomen ${personaTerms.singularLower}`, value: state.netIncome },
        { label: 'Uitkeringskosten', value: state.benefitCost },
        { label: 'Uitvoeringskosten bijstand', value: state.publicCost },
        { label: 'Waarde vrijwilligerswerk', value: state.volunteerValue },
    ]

    return (
        <>
            <div className="participation-step-row">
                <div className={`participation-step${muted ? ' participation-step-muted' : ''}`}>
                    <span className="participation-step-num">{state.ladderStep || '–'}</span>
                </div>
                <div className="participation-step-meta">
                    <div className="participation-ladder-label">
                        {state.ladderStep
                            ? `Trede ${state.ladderStep} · ${LADDER_LABELS[state.ladderStep]}`
                            : 'Geen trede'}
                    </div>
                    <div className="participation-situation">{state.situationLabel || '-'}</div>
                </div>
            </div>

            <div className="participation-result">
                <div className="participation-result-head">
                    <span className="lab">{label}</span>
                    {meta && <span className="meta">{meta}</span>}
                </div>
                <table className="participation-result-table">
                    <tbody>
                        {rows.map((row) => (
                            <tr key={row.label} className={row.value < 0 ? 'participation-negative' : ''}>
                                <td>{row.label}</td>
                                <td>{formatEuro(row.value)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default ParticipationResult
